const typeImg = (file) => {
  let ext = '';
  switch (file.type) {
    case 'image/png':
      ext = '.png'
    break;
    case 'image/gif':
      ext = '.gif'
    break;
    case 'image/jpg':
      ext = '.jpg'
    break;
    case 'application/pdf':
      ext = '.pdf'
    break;
    default:
      ext = '.jpeg'
    break;
  }
  return ext; 
}

export default typeImg;